import { render, staticRenderFns } from "./unionpayOrder.vue?vue&type=template&id=170aa966&scoped=true&"
import script from "./unionpayOrder.vue?vue&type=script&lang=js&"
export * from "./unionpayOrder.vue?vue&type=script&lang=js&"
import style0 from "./unionpayOrder.vue?vue&type=style&index=0&id=170aa966&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "170aa966",
  null
  
)

export default component.exports